import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import projectData from '../data/projectData';
import '../styles/Portfolio.css';

const Portfolio = () => {
  return (
    <div className="portfolio">
      <SEO
        title="Portfolio | Bularis Tech"
        description="Explore software products and projects developed by Bularis Tech, including AI voice automation and custom business applications."
        path="/portfolio"
      />
      <div className="portfolio-header">
        <h1>Our Portfolio</h1>
        <p>Explore software products and projects developed by Bularis Tech.</p>
      </div>
      <div className="portfolio-gallery">
        {projectData.map((project) => (
          <Link to={`/portfolio/${project.id}`} key={project.id} className="portfolio-item">
            {/* <img src={project.image} alt={project.title} /> */}
            <h3>{project.title}</h3>
            <p>{project.shortDesc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
